import { useRequest } from 'ahooks';
import { useEffect } from 'react';
import { useReadyInfo } from '@/providers/ReadyProvider';
import { fetchMbrCeremonyList } from '@/services/account';

/**
 * 获取入会礼包列表数据
 */
const useMbrCeremonyList = () => {
  const { mbrCeremonyList, setMbrCeremonyList } = useReadyInfo();

  const {
    run: getMbrCeremonyList,
    data,
    loading,
  } = useRequest(fetchMbrCeremonyList, { manual: true });

  useEffect(() => {
    if (!mbrCeremonyList || !mbrCeremonyList?.length) {
      getMbrCeremonyList().then((res) => setMbrCeremonyList(res ?? []));
    }
  }, [mbrCeremonyList]);

  return {
    data: (mbrCeremonyList || data) ?? [],
    loading,
  };
};

export default useMbrCeremonyList;
